<div class="shimmer-box f-ac" :style="widthStyle"><div class="shimmer-animation"></div></div>